import $ from 'jquery';
import ko from 'knockout';
import _ from 'lodash';
import Highcharts from 'highcharts';
import templateCommon from '../../../app/helpers/template-common';
import templateMarkup from 'raw-loader!./flexigraph-widget.html';
import FormatterCommon from '../../../app/data-formatters/formatter-common';
import './ko-flexichart';
import DataProvider from "../../../app/data-framework/data-provider";
import LoginService from "../../../services/login.service";

function FlexiGraphWidget(params) {
    var self = this;

    self.params = params;

    self.observableOptions = params.observableOptions;

    if (!ko.isObservable(self.observableOptions)) {
        // flexigraph-widget requires an observableOptions observable, it is what drives
        // the widget.
        throw new Error('Missing observableOptions');
    }

    self.observableData = params.observableData;
    self.widgetSignals = params.widgetSignals;
    self.clickCallback = params.clickCallback;

    var options = self.observableOptions();

    self.id = options.id;
    self.panelTemplate = params.panelTemplate;
    self.specialColorMetrics = ['callstatus', 'qualityclass', 'endpointsubcategory', 'packetlossclass'];
    self.defaultPalette = [
        '#17b2d1', '#582f2c', '#232970',
        '#e4b436', '#bce06d', '#67687a',
        '#e9594e', '#2cc0a2', '#156397',
        '#82d0cd', '#444f5e'
    ];
    self.legend = ko.observableArray([]);
    self.filterHtml = ko.observable(options.filter);

    self.subscriptions = [];

    self.chartType = ko.isObservable(params.chartType)
        ? params.chartType
        : ko.observable(params.chartType);

    self.headerVisible = params.headerVisible;
    self.headerSizingClass = ko.pureComputed(function() {
        return ko.unwrap(self.headerVisible) ? 'headerSizing' : '';
    });

    self.subscriptions.push(
        self.chartType.subscribe(function () {
            self.chartData = getHighchartsDataAndOptions(params.observableData(), self);
        }, self)
    );

    self.chartData = getHighchartsDataAndOptions(params.observableData(), self);

    var data = self.observableData();

    var metricIndex = options.type === 'Trend' ? 1 : 0;
    if (data.display && self.specialColorMetrics.indexOf(data.display[metricIndex]) >= 0) {
        data.datasets = setUniqueColors(data.datasets, data.display[metricIndex]);
    }

    self.dataAndOptions = ko.observable({
        id: self.id,
        data: self.chartData,
        legendLength: 0,
        clickCallback: self.clickCallback,
        selectedIndexes: []
    });

    self.subscriptions.push(self.observableData.subscribe(function () {
        self.DataUpdated();
    }));
}

FlexiGraphWidget.prototype.DataUpdated = function () {
    var self = this;
    self.RefreshData();
};

FlexiGraphWidget.prototype.dispatchResize = function () {
    var self = this;
    if (_.isFunction(_.get(self, 'widgetSignals.resizeSignal.dispatch'))) {
        var height = $('#' + self.id).height() + 60 /*add panel header height*/;
        self.widgetSignals.resizeSignal.dispatch(self.id, height);
    }
};

// This runs when the component is torn down. Put here any logic necessary to clean up,
// for example cancelling setTimeouts or disposing Knockout subscriptions/computeds.
FlexiGraphWidget.prototype.dispose = function () {
    var self = this;
    self.subscriptions.forEach(function (sub) {
        sub.dispose();
    });
};

FlexiGraphWidget.prototype.RefreshData = function () {
    var self = this;
    var data = self.observableData();

    if (data && data.datasets) {
        var metricIndex = self.observableOptions().type === 'Trend' ? 1 : 0;

        if (data.display && self.specialColorMetrics.indexOf(data.display[metricIndex]) >= 0) {
            data.datasets = setUniqueColors(data.datasets, data.display[metricIndex]);
        }

        self.chartData = getHighchartsDataAndOptions(data, self);

        var chartDataAndOptions = {
            clickCallback: self.clickCallback,
            data: self.chartData,
            id: self.id,
            legendLength: data.legend ? data.legend.length : 0,
            selectedIndexes: data.selectedIndexes ? data.selectedIndexes : []
        };

        if (self.widgetSignals) {
            if (self.widgetSignals.reflowSignal) {
                chartDataAndOptions.reflowSignal = self.widgetSignals.reflowSignal;
            }

            if (_.isFunction(_.get(self.widgetSignals, 'dataLoaded.dispatch'))) {
                self.widgetSignals.dataLoaded.dispatch();
            }
            self.dispatchResize();
        }

        self.dataAndOptions(chartDataAndOptions);
    }
};

function getStackedAreaChartDataAndOptions(data, self) {
    var hasPercentageFlag = metricHasPercentageFlag(self.observableOptions(), data);
    var result = {
        credits: {
            enabled: false
        },
        chart: {
            styledMode: true,
            type: 'area'
        },
        lang: { noData: null },
                    title: false,
        time: {
            useUTC: true,
        },
        xAxis: {
            type: 'datetime',
            startOfWeek: 0,
            crosshair: true
        },
        yAxis: {
            title: false
        },
        plotOptions: {
            area: {
                stacking: 'normal',
            },
            series: {
                marker: {
                    enabled: !hasMultipleDataItems(data)
                },
                label: {
                    enabled: false,
                },
                point: { events: { click: self.clickCallback } }
            }
        },
        legend: {
            itemStyle: {
                width: '150px',
                textOverflow: 'ellipsis',
                overflow: 'hidden'
            },
            margin: 8,
            padding: 4,
            alignColumns: false,
        },
        tooltip: {
            shared: true,
            valueDecimals: 2,
            footerFormat: '<br/>Total: <span class="highcharts-strong">{point.total}</span>',
        },
        series: getAreaChartDataSeries(data, self.observableOptions())
    };
    if (hasPercentageFlag) {
        result.tooltip.valueSuffix = '%';
    }

    if (data) {
        if (!_.isEmpty(data.ylabelSuffix)) {
            _.set(result, 'yAxis.labels.format', '{value}' + data.ylabelSuffix);
        }

        if (!_.isEmpty(data.scaleMax)) {
            _.set(result, 'yAxis.min', 0);
            _.set(result, 'yAxis.max', data.scaleMax);

        } else if (hasPercentageFlag) {
            _.set(result, 'yAxis.tickPositioner', percentageTickPositioner);
        }
    }

    return result;
}
function getAreaChartDataAndOptions(data, self) {
    var hasPercentageFlag = metricHasPercentageFlag(self.observableOptions(), data);
    var result = {
        credits: {
            enabled: false
        },
        chart: {
            styledMode: true,
            type: 'area'
        },
        lang: { noData: null },
                    title: false,
        time: {
            useUTC: true,
        },
        xAxis: {
            type: 'datetime',
            startOfWeek: 0,
            crosshair: true
        },
        yAxis: {
            title: false
        },
        plotOptions: {
            series: {
                marker: {
                    enabled: !hasMultipleDataItems(data)
                },
                label: {
                    enabled: false,
                },
                point: { events: { click: self.clickCallback } }
            }
        },
        legend: {
            itemStyle: {
                width: '150px',
                textOverflow: 'ellipsis',
                overflow: 'hidden'
            },
            margin: 8,
            padding: 4,
            alignColumns: false,
        },
        tooltip: {
            shared: true,
            valueDecimals: 2
        },
        series: getAreaChartDataSeries(data, self.observableOptions())
    };
    if (hasPercentageFlag) {
        result.tooltip.valueSuffix = '%';
    }

    if (data) {
        if (!_.isEmpty(data.ylabelSuffix)) {
            _.set(result, 'yAxis.labels.format', '{value}' + data.ylabelSuffix);
        }

        if (!_.isEmpty(data.scaleMax)) {
            _.set(result, 'yAxis.min', 0);
            _.set(result, 'yAxis.max', data.scaleMax);

        } else if (hasPercentageFlag) {
            _.set(result, 'yAxis.tickPositioner', percentageTickPositioner);
        }
    }

    return result;
}

/**
 * Returns a list of ticks in 10% increments. Max tick is 100 if no
 * data point is higher than 100%, otherwise max tick is the next value
 * in 10% increments that includes the max data value.
 *
 * This is called in the context of the Highcharts instance. The 'this'
 * reference points to the Highcharts object.
 *
 * Fixes #UI-1031
 */
function percentageTickPositioner() {
    /*jshint validthis: true */
    var maxTick = Math.max(_.ceil(this.dataMax, -1), 100);
    return _.range(0, maxTick + 1 /*+1 so the maxTick gets included in the range*/, 10);
}

function getAreaChartDataSeries(data) {
    return _.get(data, 'datasets', []);
}

function getBarTrendDataAndOptions(data, self) {
    var result = {
        credits: { enabled: false },
        chart: { styledMode: true, type: 'column' },
        lang: { noData: null },
        plotOptions: {
            series: {
                stacking: 'normal',
                point: { events: { click: self.clickCallback } },
                label: {
                    enabled: false,
                },
                dataLabels: { enabled: false }
            }
        },
        title: false,
        time: {
            useUTC: true,
        },
        yAxis: { title: false },
        xAxis: {
            tickWidth: 1,
            type: 'datetime',
            startOfWeek: 0,
            crosshair: true
        },
        series: data.datasets,
        colors: self.defaultPalette
    };
    return result;
}

function getHighchartsDataAndOptions(data, self) {
    var chartType = ko.unwrap(self.chartType);
    if (chartType === 'pie') {
        return getPieChartDataAndOptions(data, self);
    }
    if (chartType === 'bar') {
        return getStackedColumnChartDataAndOptions(data, self);
    }
    if (chartType === 'bartrend') {
        return getBarTrendDataAndOptions(data, self);
    }
    if (chartType === 'areatrend') {
        return sanitizeSeriesName(getAreaChartDataAndOptions(data, self));
    }
    if (chartType === 'stackedareatrend') {
        return sanitizeSeriesName(getStackedAreaChartDataAndOptions(data, self));
    }
    return sanitizeSeriesName(getLineChartDataAndOptions(data, self));
}

function sanitizeSeriesName(data) {
    if (data.series) {
        _.forEach(data.series, function(series) {
            if (series.name) {
                series.name = FormatterCommon.sanitize(series.name);
            }
        })
    }
    return data;
}

function getLineChartDataSeries(data) {
    return _.get(data, 'datasets', []);
}

function getLineChartDataAndOptions(data, self) {
    var hasPercentageFlag = metricHasPercentageFlag(self.observableOptions(), data);
    var result = {
        credits: {
            enabled: false
        },
        chart: { styledMode: true },
        lang: { noData: null },
        title: false,
        time: {
            useUTC: true,
        },
        xAxis: {
            type: 'datetime',
            startOfWeek: 0,
            crosshair: true
        },
        yAxis: {
            title: false,
            labels: {}
        },
        plotOptions: {
            series: {
                allowPointSelect: true,
                marker: {
                    radius: 1,
                    states: {
                        select: {
                            fillColor: '#17b2d1',
                            lineWidth: 0,
                            radius: 4
                        }
                    }
                },
                label: {
                    enabled: false,
                },
                point: {
                    events: {
                        click: self.clickCallback
                    }
                }
            }
        },
        legend: {
            itemStyle: {
                width: '150px',
                textOverflow: 'ellipsis',
                overflow: 'hidden'
            },
            margin: 8,
            padding: 4,
            alignColumns: false,
        },
        tooltip: {
            shared: true,
            valueDecimals: 2
        },
        series: getLineChartDataSeries(data, self.observableOptions())
    };
    if (hasPercentageFlag) {
        result.tooltip.valueSuffix = '%';
    }

    // if (LoginService.userObject.farmG2) {
    //     result.time = {
    //         timezone: LoginService.userObject.timezoneId
    //     };
    // }


    if (data) {
        if (!_.isEmpty(data.ylabelSuffix)) {
            _.set(result, 'yAxis.labels.format', '{value}' + data.ylabelSuffix);
        }

        if (!_.isEmpty(data.scaleMax)) {
            _.set(result, 'yAxis.min', 0);
            _.set(result, 'yAxis.max', data.scaleMax);

        } else if (hasPercentageFlag) {
            _.set(result, 'yAxis.tickPositioner', percentageTickPositioner);
        }
    }

    return result;
}

function getPieChartDataAndOptions(data, self) {
    var result = {
        credits: {
            enabled: false
        },
        chart: {
            styledMode: true,
            type: 'pie',
            spacing: [5, 5, 0, 5],
        },
        lang: { noData: null },
        title: false,
        plotOptions: {
            series: {
                label: {
                    enabled: false,
                },
                point: {
                    events: {
                        click: self.clickCallback
                    }
                }
            },
            pie: {
                borderRadius: 0,
                startAngle: 0,
                colors: data.colors || self.defaultPalette,
                size: 220,
                dataLabels: {
                    style: {
                        textOverflow: 'ellipsis' // fix for bug in highcharts
                    }
                }
            }
        },
        legend: {
            itemStyle: {
                width: '150px',
                textOverflow: 'ellipsis',
                overflow: 'hidden'
            },
            margin: 8,
            padding: 4,
            alignColumns: false,
            maxHeight: 70,
            navigation: {
                arrowSize: 10,
            },
        },
        series: getPieChartDataSeries(data, self.observableOptions()),
        tooltip: {
            useHTML: true,
            formatter: getTooltipFormatter
        },
        displayTotal: true
    };
    return result;
}

function getPieChartDataSeries(data) {
    if (_.isEmpty(_.get(data, 'datasets'))) {
        return [];
    }
    data.datasets[0].innerSize = '50%';
    data.datasets[0].showInLegend = true;
    data.datasets[0].dataLabels = {
        enabled: true,
        format: "{y:.0f} ({percentage: .1f}%)"
    };
    return data.datasets;
}

function getFormatter(hasPercentage) {
    let percentString = hasPercentage ? '%' : '';
    return function(chartData) {
        let series = chartData.chart.hoverSeries;
        // start with header, all points should have same date as key
        let formatedString = '<small>' + Highcharts.dateFormat('%A, %b %e, %Y', this.points[0].key) + '</small><br /><table>';
        // now add points
        this.points.forEach(function(point){
            formatedString += '<tr>' +
            '  <td style="color:' + point.series.color + '">' + FormatterCommon.sanitize(point.series.name) + ':</td>' +
            '  <td style="text-align:right;"><b>' + FormatterCommon.sanitize(point.y.toFixed(2)) + percentString + '</b></td>' +
            '</tr>';
          });
        return formatedString + '</table>';
    };
}

function getStackedColumnChartDataAndOptions(data, self) {
    var result = {
        credits: { enabled: false },
        chart: { styledMode: true, type: 'column' },
        lang: { noData: null },
        plotOptions: {
            series: {
                stacking: 'normal',
                label: {
                    enabled: false,
                },
                point: { events: { click: self.clickCallback } },
                dataLabels: { enabled: false }
            },
            column: {
                colorByPoint: true,
                colors: data.colors || self.defaultPalette
            }
        },
        title: false,
        time: {
            useUTC: true,
        },
        yAxis: { title: false },
        xAxis: { tickWidth: 1, categories: getStackedColumnChartXAxisCategories(data) },
        series: getStackedColumnChartDataSeries(data, self.observableOptions()),
        tooltip: {
            useHTML: true,
            formatter: getTooltipFormatter
        }
    };
    return result;
}

function getStackedColumnChartDataSeries(data) {
    if (!data) {
        return [];
    }

    if (data.datasets) {
        return data.datasets.map(function (dataset) {
            dataset.showInLegend = false;

            return dataset;
        });
    }

    if (data.dataArray) {
        return [{ data: data.dataArray, showInLegend: false }];
    }
}

function getStackedColumnChartXAxisCategories(data) {
    return _.get(data, 'xAxisCategories', []);
}

function getTooltipFormatter() {
    /* jshint validthis: true */
    // <this> refers to the Highcharts graph object on which getTooltiFormatter is invoked.
    return '<b>' + FormatterCommon.sanitize(this.point.name) + ' </b>' +
        '<p>' + FormatterCommon.sanitize(this.series.name) + ': ' + '<b>' + this.y.toFixed(2) + '</b>' + '</p>';
}


function getUniqueColorIndexForDataset(dataset, metric) {
    var colors = {
        callstatus: {
            connected: 14,
            notconnected: 15,
            unknown: 16
        },
        endpointsubcategory: {
            group: 17,
            personal: 18,
            phone: 19,
            software: 20,
            unknown: 21
        },
        qualityclass: {
            bad: 10,
            fair: 11,
            good: 12,
            unknown: 13
        },
        packetlossclass: {
            dpacketloss10: 17,
            cpacketlossbetween2and10: 10,
            bpacketloss2: 11,
            anopacketloss: 12
        }
    };

    var datasetName = _.toLower(dataset.name).replace(/[\s()%<>]/g,'');
    return _.get(colors, [metric, datasetName]);
}

function hasMultipleDataItems(data) {
    return _.get(data, 'datasets[0].data', []).length > 1;
}

function metricHasPercentageFlag(options, data) {
    var metricPath = 'metadata.Table';
    var metricKeyPath = 'selectedMetricColumnNames[0]';
    var hasPercentageFlag;

    if (!_.has(options, metricKeyPath) || !_.has(data, metricPath)) {
        hasPercentageFlag = false;
    }
    else {
        var metricKey = _.toLower(_.get(options, metricKeyPath));
        if (_.isEmpty(metricKey)) {
            hasPercentageFlag = false;
        }
        else {
            var metric = _.get(data, metricPath);
            metric = _.find(metric, ['columnKey', metricKey]);
            hasPercentageFlag = (_.get(metric, 'percentageFlag', false) === 1);
        }
    }
    return hasPercentageFlag;
}

function setUniqueColors(datasets, metric) {
    return _.map(datasets, function (dataset) {
        // if trend panel
        if (dataset.sum !== undefined && !_.isEmpty(dataset.name)) {
            dataset.colorIndex = getUniqueColorIndexForDataset(dataset, metric);
            return dataset;
        }
        dataset.data.forEach(function (dataItem) {
            dataItem.colorIndex = getUniqueColorIndexForDataset(dataItem, metric);
        });
        return dataset;
    });
}

export default { synchronous: true, template: templateMarkup, viewModel: FlexiGraphWidget };
